import React from 'react';
import PropTypes from 'prop-types';
import { ActionLink } from './util/action-link';

export const Footer = props => (
  <div className="notification-queue-footer">
    <ActionLink {...props} />
    {props.isUINext && props.hintMessage && (
      <div className="hint-message">
        <span className="hint-message-image" />
        <div className="hint-message-text">{props.hintMessage}</div>
      </div>
    )}
  </div>
);

Footer.propTypes = {
  isUINext: PropTypes.bool.isRequired,
  hintMessage: PropTypes.string,
};

Footer.defaultProps = {
  hintMessage: undefined,
};
